{
  "blocks": [
    {
      "id": "program-her-optimization",
      "kind": "program",
      "tags": ["optimization", "her", "pre-cycle", "supplements", "lifestyle"],
      "title": "Her 90-Day Optimization",
      "subtitle": "Optimize the environment for your maturing eggs before treatment",
      "icon": "🌱",
      "body": {
        "duration": "3 months",
        "includes": [
          "Baseline fertility assessment (AMH, FSH, LH, estradiol, thyroid, Vitamin D)",
          "Targeted supplement protocol (CoQ10, Vitamin D, Omega-3, Methylfolate)",
          "Lifestyle guidance (sleep, exercise, stress management)",
          "Monthly check-in questionnaires",
          "90-day retest to track trends"
        ],
        "priceRange": {
          "low": 400,
          "high": 800
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "her",
        "category": "optimization",
        "moduleIds": [
          "module-female-hormone-baseline",
          "module-female-optimization"
        ],
        "phases": [
          {
            "title": "Baseline",
            "description": "Understand your starting numbers",
            "moduleIds": ["module-female-hormone-baseline"]
          },
          {
            "title": "Optimize",
            "description": "90 days of supplements and lifestyle changes",
            "moduleIds": ["module-female-optimization"]
          }
        ],
        "steps": [
          {
            "title": "Assessment",
            "description": "Hormone panel and ultrasound to establish your baseline."
          },
          {
            "title": "Begin protocol",
            "description": "Start supplements and lifestyle adjustments targeting the 90-day egg maturation window."
          },
          {
            "title": "Retest",
            "description": "Repeat labs at 90 days. Vitamin D and thyroid should be optimized. AMH tracked for trend."
          }
        ]
      },
      "sources": [
        {
          "title": "Coenzyme Q10 supplementation and oocyte quality",
          "journal": "Reproductive BioMedicine Online",
          "year": 2021,
          "evidenceLevel": "rct"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-her-optimization",
      "to": "module-female-hormone-baseline",
      "type": "contains"
    },
    {
      "from": "program-her-optimization",
      "to": "module-female-optimization",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
